module.exports = __webpack_public_path__ + "static/media/logos_166x50_ZUAE.9efa09f2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_166x50_ZUAE.jpg
// module id = 232
// module chunks = 0